









































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DoctorSelector from "@/components/DoctorSelector.vue";
import PatientEditor from "@/components/Patient/PatientEditor.vue";
import PatientRegisterCard from "@/components/Patient/PatientRegisterModal.vue";
import PatientInvitationCard from "@/components/Patient/PatientInvitationModal.vue";
import { PatientModel } from "@/models/patient";
import { IAuthService } from '@/interfaces/Services';
import { auth as authStore, doctor as doctorStore,  patient as patientStore } from "@/store/modules";
import { IPatientService } from "@/interfaces/Services";
import MassActionPerformModal, { MassActionItem } from '@/components/MassActionPerformModal.vue';
import { inject } from "inversify-props";
import LambdaDownloader from "@/utils/lambda_downloader";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { DrugGroupModel } from '../../models/drug_group';

enum PatientActionable {
  Recovery = 'Recovery',
  ResetAccess = 'ResetAccess',
  Register = 'Register',
  Invite = 'Invite'
}

@Component({
  components: {
    DoctorSelector,
    PatientEditor,
    PatientRegisterCard,
    PatientInvitationCard,
    MassActionPerformModal,
  }
})
export class PatientList extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  registerModal = false;
  registerInProgress = false;
  patientsToBeRegistered: PatientModel[] = [];
  invitationModal = false;
  invitationInProgress = false;
  patientsToBeInvited: PatientModel[] = [];

  private recoveryModal = {
    visible: false,
    inProgress: false,
    queue: [] as MassActionItem[]
  }; 

  private resetModal = {
    visible: false,
    inProgress: false,
    queue: [] as MassActionItem[]
  };

  private register(patients: PatientModel[]) {
    this.patientsToBeRegistered = [...patients];
    this.registerInProgress = true;
    this.registerModal = true;
  }

  onRegisterComplete() {
    this.registerInProgress = false;
  }

  onRegisterModalClose() {
    this.patientsToBeRegistered = [];
    this.refresh();
  }

  private invite(patients: PatientModel[]) {
    this.patientsToBeInvited = [...patients];
    this.invitationInProgress = true;
    this.invitationModal = true;
  }

  onInvitationComplete() {
    this.invitationInProgress = false;
  }

  onInvitationModalClose() {
    this.patientsToBeInvited = [];
    this.refresh();
  }

  private isSelectedActionable(
    items: PatientModel[],
    check: PatientActionable,
    matchAll: boolean = true,
  ): boolean {
    let matchCount: number = 0;
    items.forEach((item) => {
      if (!item) {
        return;
      }
      switch (check) {
        case PatientActionable.Recovery:
        case PatientActionable.ResetAccess:
          if (item.$isRegisteredUser) {
            matchCount++;
          }
          break;
        case PatientActionable.Register:
        case PatientActionable.Invite:
          if (!item.$isRegisteredUser) {
            matchCount++;
          }
          break;
        default:
          throw new Error(`Unknown [PatientActionable.${check}].`);
          break;
      }
    });

    return matchAll ? matchCount == items.length : matchCount > 0;
  }

  recovery(items: PatientModel[]) {
    this.recoveryModal.queue = [...items].map<MassActionItem>((item: PatientModel) => {
      return {
        model: item,
        identifier: `${item.name} (${item.email})`,
        getActionResult: async () => item,
      };
    });
    this.recoveryModal.inProgress = true;
    this.recoveryModal.visible = true;
  }

  resetAccess(items: PatientModel[]) {
    this.resetModal.queue = [...items].map<MassActionItem>((item: PatientModel) => {
      return {
        model: item,
        identifier: `${item.name} (${item.email})`,
        getActionResult: async () => this.patientService.reset(item.$id!.toString())
      };
    });
    this.resetModal.inProgress = true;
    this.resetModal.visible = true;
  }

  private componentKey = 0;
  private async refresh() {
    this.isLoading = true;
    try {
      let size = 100,
        page = 1,
        total = 0;
      do {
        const [items, {}] = await this.patientService.getMany(page, size);
        this.items = [...items];
      } while (page * size < total);
    } finally {
      this.isLoading = false;
    }
  }

  getGoogleMapsAddress(address: any) {
    let str = `H-${address.postal_code}, ${address.city}, ${address.address_line_1}`;
    return "https://maps.google.com/?q=" + encodeURIComponent(str);
  }

  private selected: PatientModel[] = [];
  private get headers() {
    return [
      {
        text: this.$t('patient.fields.name'),
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: this.$t('patient.fields.socialSecurityNo'),
        align: "left",
        sortable: true,
        value: "socialSecurityNo"
      },
      {
        text: this.$t('patient.fields.phoneNo'),
        align: "left",
        sortable: true,
        value: "phoneNo"
      },
      {
        text: this.$t('patient.fields.email'),
        align: "left",
        sortable: true,
        value: "email"
      },
      {
        text: this.$t('patient.fields.temporaryAddress'),
        align: "left",
        sortable: true,
        value: "address"
      },
      {
        text: "",
        value: "action",
        sortable: false,
        align: "right"
      }
    ];
  }

  private isLoading = true;
  private items: Array<any> = [];
  private search: string = "";

  async mounted() {
    this.refresh();
  }

  onRowClick(item: PatientModel) {
    this.$router.push({path: `/dashboard/patients/${item.$id}`})
  }

  onRecoveryComplete() {
    this.recoveryModal.inProgress = false;
  }

  onRecoveryModalClose() {
    this.recoveryModal.queue = [];
    this.recoveryModal.inProgress = false;
    this.recoveryModal.visible = false;
    this.refresh();
  }
  
  onResetComplete() {
    this.resetModal.inProgress = false;
  }

  onResetModalClose() {
    this.resetModal.queue = [];
    this.resetModal.inProgress = false;
    this.resetModal.visible = false;
    this.refresh();
  }

  async downloadRecoveryKey(email: string, recoveryKey: string) {
    if (this.isLoading) {
      return;
    }

    const download = new LambdaDownloader(
      {key: recoveryKey, email},
      'recovery-key-to-pdf',
      `hemonaplo-recovery-${email}`,
      (isLoading) => this.isLoading = isLoading
    );
    await download.start();
  }
}

export default PatientList;
